import React from 'react'

const Testimonial_Area_Start = () => {
  return (
    <div>
            <section class="testimonials-area rel z-1">
            <div class="container">
                <div class="testimonials-wrap bgc-lighter">
                    <div class="row">
                        <div class="col-lg-5 rel" data-aos="fade-right" data-aos-duration="1500" data-aos-offset="50">
                        <div className="testimonial-left-image rmb-55" style={{ backgroundImage: "url('https://images.pexels.com/photos/3791901/pexels-photo-3791901.jpeg?auto=compress&cs=tinysrgb&w=600')" }}></div>

                        </div>
                        <div class="col-lg-7">
                            <div class="testimonial-right-content" data-aos="fade-left" data-aos-duration="1500" data-aos-offset="50">
                                <div class="section-title mb-55">
                                    <h2><span>5280</span>  Global Clients Say About Us Services</h2>
                                </div>
                                <div class="testimonials-active">
                                    <div class="testimonial-item">
                                        <div class="testi-header">
                                            <div class="quote"><i class="flaticon-double-quotes"></i></div>
                                            <h4>Quality Services</h4>
                                            <div class="ratting">
                                                <i class="fas fa-star"></i>
                                                <i class="fas fa-star"></i>
                                                <i class="fas fa-star"></i>
                                                <i class="fas fa-star"></i>
                                                <i class="fas fa-star"></i>
                                            </div>
                                        </div>
                                        <div class="text">"Our trip was absolutely a perfect, thanks this travel agency! They took care of every detail, from to accommodations, and even suggested incredible experiences"</div>
                                        <div class="author">
                                            <div class="image"><img src="assets/images/testimonials/author.jpg" alt="Author"/></div>
                                            <div class="content">
                                                <h5>Randall V. Vasquez</h5>
                                                <span>Graphics Designer</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="testimonial-item">
                                        <div class="testi-header">
                                            <div class="quote"><i class="flaticon-double-quotes"></i></div>
                                            <h4>Quality Services</h4>
                                            <div class="ratting">
                                                <i class="fas fa-star"></i>
                                                <i class="fas fa-star"></i>
                                                <i class="fas fa-star"></i>
                                                <i class="fas fa-star"></i>
                                                <i class="fas fa-star"></i>
                                            </div>
                                        </div>
                                        <div class="text">"Our trip was absolutely a perfect, thanks this travel agency! They took care of every detail, from to accommodations, and even suggested incredible experiences"</div>
                                        <div class="author">
                                            <div class="image"><img src="assets/images/testimonials/author.jpg" alt="Author"/></div>
                                            <div class="content">
                                                <h5>Randall V. Vasquez</h5>
                                                <span>Graphics Designer</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
  )
}

export default Testimonial_Area_Start
